import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";

import { Nav } from "react-bootstrap";

const Logout: React.FC = () => {
  const { user, setUser, instance } = useAuth(); // Use the global user state
  const [, setAccessToken] = useState<string | null>(null); // Access token state
  const navigate = useNavigate();

  // Handle logout
  const logout = async () => {
    try {
      await instance.logoutPopup();
      setUser(null);
      setAccessToken(null);
      console.log("Logout successful");
      navigate("/"); // Redirect after logout
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  // Login
  if (!user) {
    return <></>;
  }

  // Logout/User Page
  return (
    <>
      <Nav.Link onClick={logout} className="nav-item">
        Logout
      </Nav.Link>
    </>
  );
};

export default Logout;
